import ColumnsComponentsPreview from './columns-components-preview';
import { ViewProps } from './columns.constants';
import * as Styled from './columns.style';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from './settings/column-settings.utils';

const ColumnsPreview = ({ columns, columnProperties }: ViewProps) => {
  return (
    <Styled.ColumnsContainer
      $colours={getAppliedColour(columnProperties?.style)}
      $showBackground={isBackgroundApplied(columnProperties?.style)}
      $showBorder={isBorderApplied(columnProperties?.style)}
      $turnOffResponsive={true}
    >
      {columns?.map(column => (
        <Styled.ColumnsColumn
          key={column.columnId}
          $colspan={column.colspan}
          $alignment={column.alignment}
          $colours={getAppliedColour(column.style)}
          $showBorder={isBorderApplied(column.style)}
          $showBackground={isBackgroundApplied(column.style)}
          $turnOffResponsive={true}
        >
          <ColumnsComponentsPreview column={column} />
        </Styled.ColumnsColumn>
      ))}
    </Styled.ColumnsContainer>
  );
};

export default ColumnsPreview;
